import request from './request'
const activity = 'ACTIVITY-SERVE'
// 活动列表
export function activityplanfindList(data) {
  return request({
    url: activity + '/activityplan/findList',
    method: 'post',
    data
  })
}
// 获取动作大类
export function getActbigtype(data) {
  return request({
    url: activity + '/actbigtype/findList',
    method: 'post',
    data
  })
}
// 获取动作小类
export function getActsubtype(data) {
  return request({
    url: activity + '/actsubtype/findList',
    method: 'post',
    data
  })
}
// 获取载体
export function getActcarrier(data) {
  return request({
    url: activity + '/actcarrier/findList',
    method: 'post',
    data
  })
}

// 获取预算类型
export function getBudgettype(data) {
  return request({
    url: activity + '/budgettype/findList',
    method: 'post',
    data
  })
}

// 预算类型获取核销部门
export function getAuditDepartment(data) {
  return request({
    url: activity + '/budgettype/getAuditDepartment',
    method: 'post',
    data
  })
}

// 新建活动
export function addActplanInfo(data) {
  return request({
    url: activity + '/activityplan/addActplanInfo',
    method: 'post',
    data
  })
}

// 查询经销商列表
export function DbrfindList(data) {
  return request({
    url: activity + '/isolation-object/findList',
    method: 'post',
    data
  })
}

// 查询活动详情
export function getActById(data) {
  return request({
    url: activity + '/activityplan/findById',
    method: 'post',
    data
  })
}

// 查询活动详情
export function updataActplan(data) {
  return request({
    url: activity + '/activityplan/updataActplanInfo',
    method: 'post',
    data
  })
}

// 活动提报列表
export function findMarketactivityList(data) {
  return request({
    url: activity + '/marketactivity/findMarketactivityList',
    method: 'post',
    data
  })
}

// 活动提报审批发起
export function marketApproveStart(data) {
  return request({
    url: activity + '/activity-approve/marketApproveStart',
    method: 'post',
    data
  })
}

// 查询当前核销节点
export function deleteMarket(data) {
  return request({
    url: activity + '/marketactivity/deleteMarket',
    method: 'post',
    data
  })
}

export function findDropDownList(data) {
  return request({
    url: activity + '/activityplan/findDropDownList',
    method: 'post',
    data
  })
}

export function deleteActplan(data) {
  return request({
    url: activity + '/activityplan/deleteActplan',
    method: 'post',
    data
  })
}

// 活动提报列表
export function addBatchActplanDealer(data) {
  return request({
    url: activity + '/actplantarget-dealer/addBatchActplanDealer',
    method: 'post',
    data
  })
}

// 获取参与活动的经销商
export function getActplanDealer(data) {
  return request({
    url: activity + '/actplantarget-dealer/findList',
    method: 'post',
    data
  })
}

// 删除参与活动的经销商
export function deleteBatchActplanDealer(data) {
  return request({
    url: activity + '/actplantarget-dealer/deleteBatchActplanDealer',
    method: 'post',
    data
  })
}

// 活动填报-新增
export function addMarketactivity(data) {
  return request({
    url: activity + '/marketactivity/addMarketactivity',
    method: 'post',
    data
  })
}

// 活动填报-新增车系
export function addStoreActivityCar(data) {
  return request({
    url: activity + '/strain-collectqty/addStoreActivityCar',
    method: 'post',
    data
  })
}

// 获取填报详情
export function getMarketactivityById(data) {
  return request({
    url: activity + '/marketactivity/findById',
    method: 'post',
    data
  })
}

// 查询门店提报参与活动的车系，集客目标
export function getCollectqtyById(data) {
  return request({
    url: activity + '/strain-collectqty/findList',
    method: 'post',
    data
  })
}

// 活动提报审核
export function marketApproveExecute(data) {
  return request({
    url: activity + '/activity-approve/marketApproveExecute',
    method: 'post',
    data
  })
}

// 活动执行核销button
export function saveMarketactWWriteoff(data) {
  return request({
    url: activity + '/marketact-writeoff/saveMarketactWWriteoff',
    method: 'post',
    data
  })
}

// 经销商核销流程开启
export function marketApproveWriteoffStart(data) {
  return request({
    url: activity + '/activity-approve/marketApproveWriteoffStart',
    method: 'post',
    data
  })
}

// 查询当前核销节点
export function findWriteoffTasks(data) {
  return request({
    url: activity + '/activity-approve/findWriteoffTasks',
    method: 'post',
    data
  })
}
// 查询核销列表
export function findList(data) {
  return request({
    url: activity + '/marketact-writeoff/findList',
    method: 'post',
    data
  })
}

// 查询核销审批历史记录
export function findWriteoffHistTasks(data) {
  return request({
    url: activity + '/activity-approve/findWriteoffHistTasks',
    method: 'post',
    data
  })
}

// 活动品牌 -> 新增 -> 项目类别
export function getProTypeSub(data) {
  return request({
    url: activity + '/activity-approve/findWriteoffHistTasks',
    method: 'post',
    data
  })
}

// 活动品牌 -> 新增 -> 树状数据源
export function getOrganizationList(data) {
  return request({
    url: activity + '/fiveLevelSource/fiveLevelSourceQuery',
    method: 'post',
    data
  })
}
// 活动来源维护 -> 新增/编辑节点
export function saveOrganizationList(data) {
  return request({
    url: activity + '/fiveLevelSource/fiveLevelSourceSave',
    method: 'post',
    data
  })
}

// 活动来源维护 -> 删除节点
export function delOrganizationList(data) {
  return request({
    url: activity + '/fiveLevelSource/fiveLevelSourceDel',
    method: 'post',
    data
  })
}

// 活动品牌 -> 查询
export function queryBrandList(data) {
  return request({
    url: activity + '/activityProject/activityProjectQuery',
    method: 'post',
    data
  })
}

// 查询活动品牌 -> 新增/修改
export function addBrand(data) {
  return request({
    url: activity + '/activityProject/activityProjectSave',
    method: 'post',
    data
  })
}

// 查询活动品牌 -> 删除
export function delBrand(data) {
  return request({
    url: activity + '/activityProject/activityProjectDel',
    method: 'post',
    data
  })
}

// 查询品牌活动预算类型List
export function queryActBudgetList(data) {
  return request({
    url: activity + '/activityInfo/activityValeTypeQuery',
    method: 'post',
    data
  })
}

// 查询品牌活动代理List
export function queryActProxyList(data) {
  return request({
    url: activity + '/executeAgent/executeAgentQuery',
    method: 'post',
    data
  })
}

// 品牌活动 -> 活动录入
export function addBrandActivity(data) {
  return request({
    url: activity + '/activityInfo/activityInfoSave',
    method: 'post',
    data
  })
}

// 品牌活动 -> 立项详情中的活动列表
export function queryBrandActivityList(data) {
  return request({
    url: activity + '/activityInfo/activityInfoQuery',
    method: 'post',
    data
  })
}

// 品牌活动 -> 立项详情中的活动列表 -> 删除
export function delBrandActivityItem(data) {
  return request({
    url: activity + '/activityInfo/activityInfoDel',
    method: 'post',
    data
  })
}

// 品牌活动 -> 立项详情中的活动列表 -> 审批
export function toApprovalBrandActivity(data) {
  return request({
    url: activity + '/activityInfo/activityInfoConfirm',
    method: 'post',
    data
  })
}

// 品牌活动 -> 立项详情-> 活动品牌 -> 活动效果：列表查询
export function queryActivityEffectList(data) {
  return request({
    url: activity + '/activityInfo/activityEffectsInfoQuery',
    method: 'post',
    data
  })
}

export function queryValueTypeByCode(data) {
  return request({
    url: activity + '/activityInfo/activityValueTypeQuery',
    method: 'post',
    data
  })
}

// 品牌活动立项 导出
export function brandLixiangOutput(data) {
  return request({
    url: activity + '/activityProject/exportActivityProject',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

// 品牌活动 导出
export function brandActivityOutput(data) {
  return request({
    url: activity + '/activityInfo/exportActivityInfo',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

// 品牌活动效果 导出
export function brandActivityEffectOutput(data) {
  return request({
    url: activity + '/activityInfo/exportActivityEffectsInfo',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

// 活动品牌来源维护 >> 导入
export function uploadActivitySource(data) {
  return request({
    url: activity + '/fiveLevelSource/importExcelData',
    method: 'post',
    timeout: 600000,
    data
  })
}

// 活动品牌来源维护 >> 下载模版
export function downloadActivitySource(data) {
  return request({
    url: activity + '/fiveLevelSource/downLoadExample',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}
// 品牌活动 -> 活动效果 -> 新增
export function saveActivityEffectInfo(data) {
  return request({
    url: activity + '/activityInfo/activityEffectsInfoSave',
    method: 'post',
    data
  })
}

// 品牌活动 -> 活动效果 -> 列表
export function queryEffectList(data) {
  return request({
    url: activity + '/activityInfo/activityEffectsInfoQuery',
    method: 'post',
    data
  })
}
// 品牌活动 -> 活动效果 -> 删除
export function deleteEffectList(data) {
  return request({
    url: activity + '/activityInfo/activityEffectsInfoDel',
    method: 'post',
    data
  })
}
// 活动品牌 -> 新增/编辑 -> 获取剩余项目金额
export function getProjectRemainingAmount(data) {
  return request({
    url: activity + '/activityProject/remainingAmountQuery',
    method: 'post',
    data
  })
}
// 活动品牌 -> 新增/编辑 -> 品系信息
export function queryCarStrainsInfo(data) {
  return request({
    url: activity + '/activitySeriesInfo/strainsInfoQuery',
    method: 'post',
    data
  })
}
// 活动品牌 -> 新增/编辑 -> 车系信息
export function queryCarSeriesInfo(data) {
  return request({
    url: activity + '/activitySeriesInfo/carSeriesInfoQuery',
    method: 'post',
    data
  })
}

export function handleActivityName(data) {
  return request({
    url: activity + '/activityInfo/handleActivityName?projectCode=' + data,
    method: 'get'
  })
}

export function exportExcel() {
  return request({
    url: activity + '/activityInfo/exportFiveLevelExcel',
    method: 'post',
    responseType: 'blob',
    timeout: 600000
  })
}

export function initNormalAct() {
  return request({
    url: activity + '/act-plan/initNormalPlanDealer',
    method: 'get'
  })
}

// export function getCarTypeList(data) {
//   return request({
//     url: activity + `/cv/getModelCodeByStrainId?strainId=${data}`,
//     method: 'get',
//   })
// }

export function getCarTypeList(data) {
  return request({
    // url: activity + `/cv/getModelCodeByStrainId?strainId=${data}`,
    url: activity + `/cv/findVehicleModelListByStrainId`,
    method: 'post',
    data
  })
}

export function getCarTypeDeleteList(data) {
  return request({
    url: activity + `/act-vehicle-model/delete`,
    method: 'post',
    data
  })
}



export function getApproveWriteOffCost(data) {
  return request({
    url: activity + '/act-plan-apply/getApproveWriteOffCost/' + data,
    method: 'get'
  })
}



// 市场活动 -> 我的待办 -> 一、二、三级来源
// export function getSourceSelectListLevel(data) {
//   return request({
//     url: activity + '/fiveLevelSource/getSourceSelectList',
//     method: 'post',
//     data
//   })
// }
